import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from "react";
import { connect, useDispatch } from "react-redux";

import { cl } from "../../../../../utilities/cl";
import {
  showAlertSuccess,
  showAlertError,
  showAlertInfo,
} from "../../../../../store/Alert/actions";
import { openModal, closeModal } from "../../../../../store/Modal/actions";
import List from "../../../../../components/DraggableList";
import SvgArrowUpDown from "../../../../../components/SVG/ArrowUpDown";
import Song from "./Songs";
import Button from "../../../../../components/Button";
import Ok from "../../../../../components/SVG/Ok";
import Trash from "../../../../../components/SVG/Trash";
import AllPlaylists from "../AllPlaylists";
import AllSongs from "../AllSongs";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SongItem from "../AllSongs/Songs";
import {
  toggleSelectedSong,
  addSongToPlaylist,
  sortSongs,
  updateMusicPositions,
  addSongsToPlaylists,
  selectMultipleSongs,
} from "../../../../../store/ContentPlaylists/actions";
import { toggleSelectedPublicSong } from "../../../../../store/PublicPlaylists/actions";
import { updateCurrentMark } from "../../../../../store/Marks/actions";
import { MEDIA_BREAKPOINT_LG } from "../../../../../utilities/breakpoints";
import ElementsGroup from "../../../../../components/ElementsGroup";
import SvgArrowDownLight from "../../../../../components/SVG/ArrowDownLight";
import { loadAssocPublicTracks } from "../../../../../store/PublicPlaylists/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import Empty from "./Empty";
import { updateFilterParams } from "../../../../../store/Modal/types/PublicSongsFilter/actions";
import { debounce } from "../../../../../utilities/debounce";
import { loadAllPublicSongs } from "../../../../../store/PublicPlaylists/actions";
import AllPublicSongs from "./AllSongs";
import ListNew from "../../../../../components/DraggableList/ListNew";

import {
  playTrack,
  pauseTrack,
  stopTrack,
  seekTrack,
} from "../../../../../store/AudioPlayer/actions";
import { store } from "../../../../../connect";
import UserPlaylist from "./UserPlaylist";
import PlaylistHeader from "./PlaylistHeader";
import { DraggebleExample } from "../../../../../components/DraggableList/DraggebleExample";
import { loading } from "../../../../../store/App/actions";

const MusicList = ({
  className = "",
  selectedPlaylists,
  songs,
  searched_value_ref,
  selected_song,
  selected_song_all,
  selected_public_song,
  placeNumber,
  active,
  toggleSelected,
  toggleSelectedSong,
  toggleSelectedPublicSong,
  updateCurrentMark,
  variant,
  selected_public,
  allPublicTracks,
  loading,
  addSongToPlaylist,
  showAlertInfo,
  showAlertError,
  openModal,
  closeModal,
  sortSongs,
  selected,
  loadAssocPublicTracks,
  filter_params,
  updateFilterParams,
  loadAllPublicSongs,
  showCurrentSongs = true,
  updateMusicPositions,
  addSongsToPlaylists,
}) => {

  const dispatch = useDispatch();

  //////////////////////////////////////////////
  const [sort_direction, setSortDirection] = useState("");
  const [offset, setOffset] = useState(0);

  const allTracksRef = useRef();
  const publicTracksRef = useRef();
  const userPlaylistRef = useRef();

  const [public_playlist_items, setPublicPlaylistItems] = useState([]);

  const [searched_value, setSearchedValue] = useState("");

  const updateSearch = useCallback(
    debounce((value) => {
      setSearchedValue(value);
    }, 2000),
    []
  );

  useEffect(
    searched_value_ref !== ""
      ? () => {
        updateSearch(searched_value_ref);
      }
      : () => setSearchedValue(searched_value_ref),
    [searched_value_ref]
  );

  const hPlay = (data) => {
    dispatch(playTrack(data));
  };
  const hPause = () => {
    dispatch(pauseTrack());
  };
  const hStop = () => {
    dispatch(stopTrack());
  };
  const hRewind = (time) => {
    console.log("HEAR");
    // time = store.getState().audioRef.current.duration * time

    // dispatch(seekTrack(time))
  };

  const hasFilter =
    filter_params.genre_name?.length > 0 ||
    filter_params.songauthor_name?.length > 0 ||
    filter_params.tempo?.length > 0;

  ///////////////////////////////////////////
  const selectAllCurrent = () => {
    let songs = userPlaylistRef.current.playlist_items_ref
    songs = songs.map(el => el.id)
    dispatch(selectMultipleSongs(songs))
  }



  const selectAllP = (e) => {
    // let songs_ids = Object.values(assoc_public_tracks).map((song) => {
    //   return Number(song.id);
    // });
    // songs_ids.forEach((id) => {
    //   if (
    //     selected_public_song.length === Object.keys(assoc_public_tracks).length
    //   ) {
    //     toggleSelectedPublicSong({
    //       id_song: id,
    //       onlyOne: songs_ids.indexOf(id) === -1 ? true : false,
    //     });
    //   } else {
    //     if (selected_public_song.indexOf(id) === -1) {
    //       toggleSelectedPublicSong({
    //         id_song: id,
    //         onlyOne: songs_ids.indexOf(id) === -1 ? true : false,
    //       });
    //     }
    //   }
    // });
    // updateCurrentMark();
  };
  const toggleSelectedP = ({ }, e) => {
    const songTitle = e.target;
    
    if (songTitle.dataset.playing) {
      return
    }
    document.getSelection().removeAllRanges();

    let id = Number(
      songTitle.dataset.songId ||
      songTitle.parentNode.dataset.songId ||
      songTitle.parentNode.parentNode.dataset.songId
    );
    let i = 0;
    let selection_arr = [];
    let reverse;
    if (e.nativeEvent.shiftKey) {
      console.log({ id, songTitle });

      e.preventDefault();
      console.log(
        ">>",
        selected.length,
        "allTracksRef:",
        allTracksRef,
        "publicTracksRef:",
        publicTracksRef
      );

      let list = publicTracksRef?.current
        ? publicTracksRef?.current?.getTracks() || []
        : allTracksRef?.current?.getTracks() || [];

      console.log({ selected, list, l: [...public_playlist_items.values()] });

      for (let song of list) {
        if (selected_public_song[0] === song.id) {
          i = 1;
          continue;
        }
        if (i === 1) {
          if (song.id !== id) {
            selection_arr.push(song.id);
          } else {
            selection_arr.push(song.id);
            break;
          }
        }
      }
      console.log({ selected_public_song });

      if (selection_arr.indexOf(id) === -1) {
        // reverse = Object.values(assoc_public_tracks).reverse();
        reverse = [];
        selection_arr = [];
        i = 0;
        for (let track of reverse) {
          if (selected_public_song[0] === track.id) {
            i = 1;
            continue;
          }
          if (i === 1) {
            if (track.id !== id) {
              console.log(track.id);
              selection_arr.push(track.id);
            } else {
              selection_arr.push(track.id);
              break;
            }
          }
        }
      }
      selection_arr.map((id) => {
        toggleSelectedPublicSong({
          id_song: id,
          onlyOne: !(
            e.ctrlKey ||
            e.metaKey ||
            e.shiftKey ||
            window.outerWidth <= MEDIA_BREAKPOINT_LG
          ),
        });
      });
      updateCurrentMark();
    }
    if (songTitle && !e.nativeEvent.shiftKey) {
      const songId = Number(
        songTitle.dataset.songId ||
        songTitle.parentNode.dataset.songId ||
        songTitle.parentNode.parentNode.dataset.songId
      );
      if (!isNaN(songId)) {
        toggleSelectedPublicSong({
          id_song: songId,
          onlyOne: !(
            e.ctrlKey ||
            e.metaKey ||
            e.shiftKey ||
            window.outerWidth <= MEDIA_BREAKPOINT_LG
          ),
        });
        updateCurrentMark();
      }
    }
  };

  className = cl(className, "Songs_collapsible");

  const playPublic = data => hPlay({ ...data, from: 'public' })

  const songRenderItem = (song, index) => ({
    id: song.id,
    name: song.name,
    element: (
      <SongItem
        key={song.id}
        id={song.id}
        name={song.name}
        variant={index % 2 == 0 ? "gray" : ""}
        songs={songs}
        selected={selected_public_song}
        tags={song.tags}
        turn={song.turn}
        cliptime={song.cliptime}
        tempo={song.tempo}
        songauthor_name={song.songauthor_name}
        hide_song_author_name={true}
        player_name={song.player_name}
        album_name={song.album_name}
        genre_name={song.genre_name}
        year={song.cdate}
        filename={song.filename}
        play={playPublic}
        pause={hPause}
        stop={hStop}
        rewind={hRewind}
      />
    ),
  });
  const getPublicItems = () => {
    // return public_playlist_items.sort((a, b) => Number(a.turn) - Number(b.turn)).map((song, index) => ({
    return public_playlist_items.map((song, index) =>
      songRenderItem(song, index)
    );
  };


  // useEffect(() => {
  //     setPublicPlaylistItems([...assoc_public_tracks.values()])
  // }, [assoc_public_tracks])

  const loadMorePublicTraks = (fromAll) => {
    setOffset(offset + 50);
    if (hasFilter) {
      updateFilterParams({ ...filter_params, offset: offset + 50 });
    } else {
      loadAssocPublicTracks({ offset: offset + 50 });
    }
    // console.log("OFFSET", offset)
    console.log(" >> >> ", { offset });
    if (fromAll) loadAllPublicSongs({ offset: offset + 50 });
    else loadAssocPublicTracks({ offset: offset + 50 });
  };

  let public_playlist_content;
  if (public_playlist_items.length > 0) {
    public_playlist_content = (
      <ListNew
        type="simple"
        // offset={offset}
        offsetAdd={50}
        // loadButton={!hasFilter && <div className="ScrollContainer__more">
        //     <div onClick={() => loadMorePublicTraks()}>
        //         Загрузить ещё
        //         <SvgArrowDownLight title="Загрузить ещё" variant="dark" size="xs" />
        //     </div>
        // </div>}
        loadMore={loadAssocPublicTracks}
        scroll={{
          on: true,
          data: {
            variant: "white",
            size: "sm",
          },
        }}
        onClick={toggleSelectedP}
        content={{ items: getPublicItems(), variant: "none" }}
        droppableId={`1`}
      />
    );
  }

  const handleResult = (result) => {
    let { destination, source } = result;
    if (!destination) return;
    if (
      (destination.droppableId === `1` && source.droppableId === `1`) ||
      !userPlaylistRef.current
    )
      return;
    const playlist_items = userPlaylistRef.current.playlist_items_ref;
    let current = playlist_items.map((song) => {
      return song.id;
    });

    if (destination.droppableId === source.droppableId) {
      if (source.droppableId === `0`) {
        const updated = Array.from(userPlaylistRef.current.playlist_items_ref);
        const [moved] = updated.splice(source.index, 1);
        updated.splice(destination.index, 0, moved);
        userPlaylistRef.current.setPlaylistItems(updated);
      } else if (destination.droppableId === `1`) {
        showAlertError({
          text: `Публичный плейлист нельзя изменять.`,
          ms: 3000,
        });
      }
      return;
    } else {
      if (destination.droppableId !== `1`) {

        const playlist = userPlaylistRef.current.currentPlaylist


        if (playlist?.address) {

          showAlertInfo({
            text: `Добавление в плейлисты с адресом потока невозможно.`,
            ms: 3000,
          });
          return
        }



        let public_playlist_item = publicTracksRef.current?.getTrackByIndex(
          source.index
        );
        public_playlist_items.splice(source.index, 1);

        if (!public_playlist_item)
          public_playlist_item = allTracksRef.current?.getTrackByIndex(
            source.index
          );

        if (current.indexOf(public_playlist_item.id) !== -1) {
          showAlertError({
            text: "Выбранная композиция уже есть в текущем списке",
            ms: 3000,
          });
          return;
        }

        playlist_items.splice(destination.index, 0, public_playlist_item);
        userPlaylistRef.current.setPlaylistItems([...playlist_items]);
        addSongToPlaylist({
          id_playlist: userPlaylistRef.current.currentPlaylistId,
          selected_song: playlist_items.map((song) => {
            return song.id;
          }),
          songs: playlist_items,
        });
      } else {
        showAlertError({
          text: `Публичный плейлист нельзя изменять.`,
          ms: 3000,
        });
        return;
      }
    }
  };

  const addSongs = (fromAll) => {
    // const fromAll = !!!selectedPlaylists[0]
    loading(true)

    const { allPlaylists, selected: selectedArr } = store.getState().playlists;
    const selected_playlists = allPlaylists.filter((playlist) =>
      selectedArr.includes(playlist.id)
    );

    let currentPlaylists = selected_playlists.filter(el => !el.address)


    if (currentPlaylists.length !== selected_playlists.length) {
      showAlertInfo({
        text: `Некоторые из выбранных плейлистов имеют адресс потока. Добавление в них невозможно.`,
        ms: 3000,
      });
      loading(false)
    }

    addSongsToPlaylists({
      playlists_ids: currentPlaylists,
      tracks_ids: selected_public_song,
    });
    return;

    for (let playlist of selected_playlists) {
      let current = playlist.songs.map((song) => {
        return song.id;
      });
      let full = [...current, ...selected_public_song];
      console.log("123", fromAll, public_playlist_items);

      let already_includes = [];
      selected_public_song.forEach((el) => {
        if (current.indexOf(el) !== -1) {
          already_includes.push(el);
        }
      });
      if (
        selected_public_song.length === already_includes.length &&
        already_includes.length !== 0
      ) {
        showAlertError({
          text:
            already_includes.length > 1
              ? `Все выбранные композиции уже есть в текущем списке`
              : "Выбранная композиция уже есть в текущем списке",
          ms: 3000,
        });
        return;
      }

      let selected = selected_public_song;
      if (already_includes.length) {
        showAlertInfo({
          text: `Некоторые из выбранных композиций уже есть в одном из выбранных списков. Они не будут повторно добавлены.`,
          ms: 3000,
        });
        selected = selected.filter((id) => already_includes.indexOf(id) !== -1);
      }

      return;
      addSongToPlaylist({
        id_playlist: playlist.id,
        selected_song: full,
        songs: playlist_items_update,
      });

      const newTracks = fromAll
        ? allTracksRef.current
          ?.getSelectedTracks()
          .filter((song) => selected.indexOf(song.id) !== -1)
        : publicTracksRef.current
          ?.getSelectedTracks()
          .filter((song) => selected.indexOf(song.id) !== -1);

      console.log({ fromAll, selected, already_includes, newTracks });

      let playlist_items_update = [
        ...Array.from(userPlaylistRef.current.playlist_items_ref),
        ...newTracks,
      ];

      userPlaylistRef.current.setPlaylistItems([...playlist_items_update]);
      console.log(";;--;;");

      addSongToPlaylist({
        id_playlist: playlist.id,
        selected_song: full,
        songs: playlist_items_update,
      });
    }
  };


  return (
    <>
      <DragDropContext onDragEnd={handleResult}>
        <UserPlaylist
          ref={userPlaylistRef}
          toggleSelected={toggleSelected}
          hPlay={hPlay}
          hStop={hStop}
          hPause={hPause}
          hRewind={hRewind}
          selectAllS={selectAllCurrent}
        />
        <div className="All_media">
          <AllPlaylists />
          <AllSongs
            public_playlist_items={public_playlist_items}
            public_playlist_content={
              <AllPublicSongs
                ref={publicTracksRef}
                preset="public_audio"
                songRenderItem={songRenderItem}
                toggleSelectedP={toggleSelectedP}
                loadMorePublicTraks={loadMorePublicTraks}
              />
            }
            all_public_content={
              <AllPublicSongs
                ref={allTracksRef}
                songRenderItem={songRenderItem}
                toggleSelectedP={toggleSelectedP}
                loadMorePublicTraks={loadMorePublicTraks}
              />
            }
            addSongs={addSongs}
            selectAll={selectAllP}
            hide_song_author_name={true}
          />
        </div>
      </DragDropContext>
    </>
  );
};

const stateToProps = (state, props) => ({
  allPublicTracks: state.public_playlists.allPublicTracks,

  markItems: state.marks[state.marks.current].items,
  selected: state.playlists.selected,
  searched_value_ref: state.search.songs.value,

  selected_song_all: state.playlists.selected_song_all,
  selected_public_song: state.public_playlists.selected_song,

  selected_public: state.public_playlists.selected,
  filter_params: state.modalPublicSongsFilter.filter_params,
});
const actionsToProps = {
  toggleSelectedSong,
  updateCurrentMark,
  toggleSelectedPublicSong,
  addSongToPlaylist,
  showAlertSuccess,
  showAlertInfo,
  showAlertError,
  openModal,
  closeModal,
  sortSongs,
  loadAssocPublicTracks,
  updateFilterParams,
  loadAllPublicSongs,
  updateMusicPositions,
  addSongsToPlaylists,
  loading
};

export default connect(stateToProps, actionsToProps)(MusicList);
